<div class="alert-calendar-widget-container">
    <div class="alert-calendar-widget-header">
        <div class="alert-calendar-widget-header-title flex items-center">
            Alert History
            @if (loading) {
                <mat-spinner class="ml-2" [diameter]="15"></mat-spinner>
            }
        </div>
        <div class="month-selector-container">
            <button mat-icon-button (click)="subtractMonth()">
                <mat-icon>keyboard_arrow_left</mat-icon>
            </button>
            <div class="month-selector-label">{{ monthSelectorLabel }}</div>
            <button mat-icon-button (click)="addMonth()" [disabled]="addMonthDisabled">
                <mat-icon>keyboard_arrow_right</mat-icon>
            </button>
        </div>
    </div>
    <div class="alert-calendars-wrapper">
        @for (calendar of displayedCalendars; track calendar) {
            <div class="alert-calendar">
                <div class="alert-calendar-week-row header-row">
                    @for (headerDay of dayHeaders; track headerDay) {
                        <div class="alert-calendar-day">
                            {{ headerDay }}
                        </div>
                    }
                </div>
                <div class="alert-calendar-date-wrapper">
                    @for (week of calendar.calendarArray; track week) {
                        <div class="alert-calendar-week-row">
                            @for (day of week; track day) {
                                <div
                                    class="alert-calendar-day"
                                    (click)="day.state !== undefined && displayAlerts(day.alerts, day.dateFormat)"
                                    [ngClass]="{
                                        hidden: day.hidden,
                                        partial: day.partial,
                                        empty: day.state === undefined,
                                        undefined: day.state === State.UNDEFINED,
                                        good: day.state === State.OK || day.state === State.WARNING,
                                        bad: day.state === State.ERROR,
                                    }"
                                >
                                    <span>{{ day.dayString }}</span>
                                    @if (day.state === State.WARNING) {
                                        <div
                                            class="rounded-full w-[27px] h-[27px] left-[-1px] top-[-1px] absolute border-2 border-error border-dashed"
                                        ></div>
                                    }
                                </div>
                            }
                        </div>
                    }
                </div>
                <div class="alert-calendar-month-name">
                    {{ calendar.displayedMonth.format('MMMM') }}
                </div>
            </div>
        }
    </div>
</div>
